import { render, staticRenderFns } from "./NewGroupStepTwo.vue?vue&type=template&id=19e88c8c&scoped=true"
import script from "./NewGroupStepTwo.vue?vue&type=script&lang=js"
export * from "./NewGroupStepTwo.vue?vue&type=script&lang=js"
import style0 from "./NewGroupStepTwo.vue?vue&type=style&index=0&id=19e88c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e88c8c",
  null
  
)

export default component.exports